import React from 'react';
import 'react-vertical-timeline-component/style.min.css'

import howIm from '../../images/howIm.jpg'
import { ContactContainer, InfoWrapper, InfoRow, TextWrapper, TopLine, Heading, Subtitle, ImgWrap, Img, InfoContainer, } from './ContactElements';

const Contact = () => {

  return (
    <ContactContainer lightBg={true} id={0}>
      <InfoWrapper>
        <InfoRow imgStart={false}>
          <TextWrapper>
            <TopLine>Contact Us</TopLine>
            <Heading lightText={false}>Let's have a conversation</Heading>
            <Subtitle darkText={true}>contact@laytrader.io</Subtitle>
            {/* <BtnWrap>
                <Button
                  to='/laytrader'
                  duration={500}
                  exact='true'
                  offset={-80}
                  primary={primary ? 1 : 0}
                  dark={dark ? 1 : 0}
                  dark2={dark2 ? 1 : 0}
                >
                  {buttonLabel}
                </Button>
              </BtnWrap> */}
          </TextWrapper>
          <ImgWrap>
            <Img src={howIm} alt={Contact} />
          </ImgWrap>
        </InfoRow>
      </InfoWrapper>
    </ContactContainer>
  );
};

export default Contact;
